import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Day, ItineraryDetailsData } from '../../../../../interfaces/src/lib/types/index';
import {
  IExcursionsResponse,
  PortItem,
  ShipData,
} from '../../../../../interfaces/src/lib/interfaces/index';
import { loadFromSessionStorage } from '../../genericUtils/genericUtils';

const initialState: ItineraryDetailsState = {
  params: { cruiseID: null },
  itineraryDetailsData: null,
  itineraryExcursionsData: null,
  loading: false,
  error: null,
  selectedItinerary: null,
  shipData: null,
  portsData: null,
  allPortsData: null,
};

export interface ItineraryDetailsState {
  params: { cruiseID: string | null };
  itineraryDetailsData: ItineraryDetailsData | null;
  itineraryExcursionsData: IExcursionsResponse | null;
  loading: boolean;
  error: string | null;
  selectedItinerary: Day | null;
  shipData: ShipData | null;
  portsData: PortItem[] | null;
  allPortsData: PortItem[] | null;
}

const itinerarySlice = createSlice({
  name: 'itineraryDetails',
  initialState: loadFromSessionStorage('itineraryData', initialState),
  reducers: {
    itineraryDetailsRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    itineraryDetailsSuccess: (state, action) => {
      state.loading = false;
      state.itineraryDetailsData = action.payload;
      state.error = null;
    },
    itineraryDetailsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    itineraryExcursionsRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    itineraryExcursionsSuccess: (state, action) => {
      state.loading = false;
      state.itineraryExcursionsData = action.payload;
      state.error = null;
    },
    itineraryExcursionsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedItinerary: (state, action: PayloadAction<number>) => {
      state.selectedItinerary = action.payload;
    },
    setShipData: (state, action: PayloadAction<ShipData>) => {
      state.shipData = action.payload;
    },
    setPortsData: (state, action: PayloadAction<PortItem[]>) => {
      state.portsData = action.payload;
    },
    clearItineraryDetailsImage: (state) => {
      if (state.itineraryDetailsData?.mapImage) state.itineraryDetailsData.mapImage = '';
    },
  },
});

export const {
  itineraryDetailsRequest,
  itineraryDetailsSuccess,
  itineraryDetailsFailure,
  itineraryExcursionsRequest,
  itineraryExcursionsSuccess,
  itineraryExcursionsFailure,
  setSelectedItinerary,
  setShipData,
  setPortsData,
  clearItineraryDetailsImage,
} = itinerarySlice.actions;

export default itinerarySlice.reducer;
